import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
	BackupPopoverComponent,
	LoaderService,
	ToasterService,
	backupTypeEnum,
} from '@arianeeprivate/wallet-shared-components';
import { NavController, Platform, PopoverController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BackupService } from '../../../providers/backup-service/backup.service';
import { UserService } from '../../../providers/user-service/user.service';

@Component({
	selector: 'app-home-backup',
	templateUrl: './home-backup.page.html',
	styleUrls: ['./home-backup.page.scss'],
})
export class HomeBackupPage implements OnInit {
	constructor(
		private navCtrl: NavController,
		private location: Location,
		private popOverCtrl: PopoverController,
		private loaderService: LoaderService,
		private backupService: BackupService,
		private toasterService: ToasterService,
		private platform: Platform,
		private userService: UserService,
	) {}

	public lastCheck = {
		isBackedUp: false,
		date: undefined,
		email: undefined,
	};

	public lastManualCheck = {
		isBackedUp: false,
		date: undefined,
		email: undefined,
	};

	private subs: Subscription[] = [];
	public isIos;
	public isAndroid;

	public hasManualyBackup = false;
	private destroy$ = new Subject();

	async ngOnInit() {
		this.isIos = this.platform.is('ios');
		this.isAndroid = this.platform.is('android');
		this.backupService
			.getBackupCurrentWallet()
			.pipe(takeUntil(this.destroy$))
			.subscribe((data: any[]) => {
				if (data.length > 0) {
					this.lastManualCheck =
						data.find((item) => item.type === backupTypeEnum.manual) ||
						this.lastManualCheck;
					this.lastCheck =
						data.find(
							(item) =>
								item.type === backupTypeEnum.google ||
								item.type === backupTypeEnum.icloud,
						) || this.lastCheck;

					// Check if cloud backup exists for current address
					this.backupService
						.checkBackup()
						.then((result) => {
							if (result) {
								this.userService.setHasBackup(true);
							}
						})
						.catch((error) => {
							console.error('Error checking cloud backup:', error);
						});
				}
			});
	}

	ionViewDidLeave() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onClickNavBack() {
		this.location.back();
	}

	manualBackup() {
		this.navCtrl.navigateForward('/backup-viewer');
	}

	onSubmitAutomaticBackup() {
		if (this.lastCheck.isBackedUp) {
			return this.validateBackup();
		} else {
			return this.automaticBackup();
		}
	}

	async automaticBackup() {
		this.loaderService.showLoader();
		await this.backupService.backupMnemonic();
		await this.backupService.checkBackup();
		this.loaderService.dismiss();

		let backupType = 'Backup.driveBackup';

		if (this.isIos) {
			backupType = 'Backup.icloudBackup';
		}

		const prodPopover = await this.popOverCtrl.create({
			component: BackupPopoverComponent,
			componentProps: { backupType: backupType },
			translucent: true,
			cssClass: 'backup-popover',
		});
		await prodPopover.present();
	}

	async validateBackup() {
		try {
			await this.loaderService.showLoader();
			await this.backupService.checkBackup();
			this.loaderService.dismiss();
			this.toasterService.showRedesigned({
				position: 'top',
				duration: 5000,
				title: 'Backup.validateBackup.onSuccess',
				icon: 'check',
				color: 'success',
			});
		} catch (e) {
			this.loaderService.dismiss();
			this.toasterService.alert({
				message: 'Backup.validateBackup.onError',
			});
		}
	}
}
